module.exports = __webpack_public_path__ + "media/webfonts/fa-solid-900-efbd5d20.eot";